import LeadsFeedbackTable from "@/app/app-shared/enquiry-entrties/feedback";
import LeadsFeedbackMobileTable from "@/app/app-shared/enquiry-entrties/feedback/mobile/LeadsFeedbackMobileTable";
import { useWindowSize } from "@/hooks/use-window-size";

function LeadsFeedbackPage() {
  const { width } = useWindowSize();
  const isMobile = width < 768; // md breakpoint

  return (
    <>{isMobile ? <LeadsFeedbackMobileTable /> : <LeadsFeedbackTable />}</>
  );
}

export default LeadsFeedbackPage;